import { FC } from "react";
import ArticleSharing from "../ArticleSharing";
import {
  InnerWrapper,
  SharingWrapper,
  Tag,
  Title,
  Wrapper,
} from "./Tags.styled";

interface Props {
  tags: {
    name: string;
    path: string;
  }[];
}

const Tags: FC<Props> = ({ tags }) => {
  if (!tags) {
    return null;
  }

  return (
    <>
      <style jsx>{`
        .tag_wrapper {
          display: flex;
          flex-wrap: wrap;
          grid-row: 2;  
        }
        @media (max-width: 820px) {
          .tag_wrapper {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
      <div>
        <InnerWrapper>
          <Wrapper>
            <Title>
              <p className="more_about">More About:</p>
              <div className="tag_wrapper">
                {tags.map((tag: any, i: number) => (
                  <Tag key={i} href={tag.path}>
                    <span>{tag.name}</span>
                  </Tag>
                ))}
              </div>
            </Title>

            <SharingWrapper>
              <ArticleSharing/>
            </SharingWrapper>
          </Wrapper>
        </InnerWrapper>
      </div>
    </>
  );
};

export default Tags;
